import { render, staticRenderFns } from "./UserProfileCertificatesSection.vue?vue&type=template&id=77754d94"
import script from "./UserProfileCertificatesSection.vue?vue&type=script&lang=js"
export * from "./UserProfileCertificatesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports